import React, { useContext } from "react";
import { SocialButton } from "@monorepo/components";
import { SignAuth0Context } from "../../Auth0Context";

import "./AppleButton.scss";
import logo from "../Apple.svg";

import { pushDataToSegment, saveLastAttemptInfo } from "../../segmentData";
import {
  SIGN_IN_ATTEMPT,
  ACCOUNT_CREATION_ATTEMPT,
  SIGN_IN_SUCCESS,
  ACCOUNT_CREATION_SUCCESS,
  ACCOUNT_CREATION_PAGE,
  SIGN_IN_PAGE
} from "../../constant";

interface AppleButtonProps {
  id?: string;
  title: string;
  imgAlt: string;
  wrappedProps?: any;
}

export const AppleButtonControl: React.FunctionComponent<AppleButtonProps> = ({
  id,
  title,
  wrappedProps,
  imgAlt
}) => {
  const auth0 = useContext(SignAuth0Context);

  const onApplePressed = (): void => {
    saveLastAttemptInfo({ label: "Apple" });
    if (id && id.includes("signUp")) {
      pushDataToSegment(ACCOUNT_CREATION_ATTEMPT, false, { label: "Apple", pageName: ACCOUNT_CREATION_PAGE });
    } else {
      pushDataToSegment(SIGN_IN_ATTEMPT, false, { label: "Apple", pageName: SIGN_IN_PAGE });
    }

    auth0.authenticateApple();

    if (id && id.includes("signUp")) {
      // we would always send succeeded (there’s no chance of failure, it’s just redirecting the user away)
      pushDataToSegment(ACCOUNT_CREATION_SUCCESS, false, { label: "Apple", pageName: ACCOUNT_CREATION_PAGE });
    } else {
      pushDataToSegment(SIGN_IN_SUCCESS, false, { label: "Apple", pageName: SIGN_IN_PAGE });
    }
  };

  return (
    <SocialButton
      id={id === undefined ? "apple" : id}
      wrappedProps={wrappedProps}
      title={title}
      imgSrc={logo}
      imgAlt={imgAlt}
      onPressed={onApplePressed}
    ></SocialButton>
  );
};

const AppleButton: React.FunctionComponent<AppleButtonProps> = React.memo(
  AppleButtonControl
);
export default AppleButton;
